module.exports = __webpack_public_path__ + "static/media/stick.90d28ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stick.png
// module id = 236
// module chunks = 0